import FixedBgTextProperties from './FixedBgTextProperties';
import ImageTextProperties from './ImageTextProperties';
import SignupProperties from './SignupProperties';
import UserProfileProperties from './UserProfileProperties';
import LoginProperties from './LoginProperties';
import BoardProperties from './BoardProperties';
import MainBannerProperties from './MainBannerProperties';
import ProductListProperties from './ProductListProperties';
import ProductDetailProperties from './ProductDetailProperties';
import FAQProperties from './FAQProperties';
import CompanyHistoryProperties from './CompanyHistoryProperties';
import MembershipSignupProperties from './MembershipSignupProperties';
import CustomMembershipSignupProperties from './CustomMembershipSignupProperties';
import BinaryLegsProperties from './BinaryLegsProperties';
import UnilevelLegsProperties from './UnilevelLegsProperties';
import ProductSliderProperties from './ProductSliderProperties';
import ImageSliderProperties from './ImageSliderProperties';
import TrendingItemsProperties from './TrendingItemsProperties';
import CartProperties from './CartProperties';
import OrderHistoryProperties from './OrderHistoryProperties';
import ParallaxProperties from './ParallaxProperties';
import AssetHistoryProperties from './AssetHistoryProperties';
import RichEditorProperties from './RichEditorProperties';
import RecommendedUsersProperties from './RecommendedUsersProperties';
import BenefitSummaryProperties from './BenefitSummaryProperties';
import MobileLayoutProperties from './MobileLayoutProperties';
import PaymentProperties from './PaymentProperties';
import CategoryMenuProperties from './CategoryMenuProperties';
import QuickMenuProperties from './QuickMenuProperties';
import DualBannerProperties from './DualBannerProperties';
import SearchBarProperties from './SearchBarProperties';

// 컴포넌트 속성 모듈들을 모아서 export
export {
  FixedBgTextProperties,
  ImageTextProperties,
  SignupProperties,
  UserProfileProperties,
  LoginProperties,
  BoardProperties,
  MainBannerProperties,
  ProductListProperties,
  ProductDetailProperties,
  FAQProperties,
  CompanyHistoryProperties,
  MembershipSignupProperties,
  CustomMembershipSignupProperties,
  BinaryLegsProperties,
  UnilevelLegsProperties,
  ProductSliderProperties,
  ImageSliderProperties,
  TrendingItemsProperties,
  CartProperties,
  OrderHistoryProperties,
  ParallaxProperties,
  AssetHistoryProperties,
  RichEditorProperties,
  RecommendedUsersProperties,
  BenefitSummaryProperties,
  MobileLayoutProperties,
  PaymentProperties,
  CategoryMenuProperties,
  QuickMenuProperties,
  DualBannerProperties,
  SearchBarProperties
};

// 컴포넌트 타입별 속성 컴포넌트 맵핑 (나중에 확장하기 쉽게)
export const ComponentPropertiesMap = {
  FIXED_BG_TEXT: FixedBgTextProperties,
  IMAGE_TEXT: ImageTextProperties,
  SIGNUP: SignupProperties,
  USER_PROFILE: UserProfileProperties,
  LOGIN: LoginProperties,
  BOARD: BoardProperties,
  MAIN_BANNER: MainBannerProperties,
  PRODUCT_LIST: ProductListProperties,
  PRODUCT_DETAIL: ProductDetailProperties,
  FAQ: FAQProperties,
  COMPANY_HISTORY: CompanyHistoryProperties,
  MEMBERSHIP_SIGNUP: MembershipSignupProperties,
  CUSTOM_MEMBERSHIP_SIGNUP: CustomMembershipSignupProperties,
  BINARY_LEGS: BinaryLegsProperties,
  UNILEVEL_LEGS: UnilevelLegsProperties,
  PRODUCT_SLIDER: ProductSliderProperties,
  IMAGE_SLIDER: ImageSliderProperties,
  TRENDING_ITEMS: TrendingItemsProperties,
  CART: CartProperties,
  ORDER_HISTORY: OrderHistoryProperties,
  PARALLAX: ParallaxProperties,
  ASSET_HISTORY: AssetHistoryProperties,
  RICH_EDITOR: RichEditorProperties,
  RECOMMENDED_USERS: RecommendedUsersProperties,
  BENEFIT_SUMMARY: BenefitSummaryProperties,
  MOBILE_LAYOUT: MobileLayoutProperties,
  PAYMENT: PaymentProperties,
  CATEGORY_MENU: CategoryMenuProperties,
  QUICK_MENU: QuickMenuProperties,
  DUAL_BANNER: DualBannerProperties,
  SEARCH_BAR: SearchBarProperties
};

export default ComponentPropertiesMap;